module.exports = "/wbalone/fonts/logo_zh_CN.c4f715c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo_zh_CN.svg
// module id = 726
// module chunks = 0